import wujiComp from '@tencent/xy-compsloader';
import componentBase from '@tencent/wuji-component-base';
import Vue from 'vue';
import * as AntdModule from 'ant-design-vue';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';

export * from './pageconfig-parser';
export * from './loader';
export * from './register';
export * from './requestor';
export * from './hmr';
export * from './replace-options';

export const initCompsLoader = (extendComps = {}) => {
  wujiComp.config(
    {
      baseComp: componentBase,
    },
    extendComps,
  );
  const staticFileHost = getStaticFileHost();
  if (staticFileHost) {
    wujiComp.setStaticFileHost('public', '', staticFileHost);
  }
};

// 非 default 组件都已经在后端隐藏了，这里只需要处理 default 组件
// default 组件指的是编辑器内置的组件
export const getHiddenComponents = () => {
  const hiddenComponent = window.GLOBAL_INFO.componentHubSettings.hiddenComponents?.default || [];
  if (Array.isArray(hiddenComponent)) {
    return {
      hideInServer: hiddenComponent,
    };
  }
  return hiddenComponent;
};

export const getStaticFileHost = () => window.GLOBAL_INFO.componentHubSettings?.staticFileHost;

export const registerModuleLoader = (type, loader) => {
  wujiComp.registerModuleLoader(type, loader);
};

export const setDefaultLibrary = (library) => {
  wujiComp.setDefaultLibrary(library);
};

export const getWujiCompInstance = () => wujiComp;

export const getCompModule = id => wujiComp.moduleManage.installedModules[id];

export const initCompDeps = () => {
// 初始化组件加载器
  initCompsLoader({
    vue: Vue,
    'ant-design-vue': AntdModule,
    'ant-design-vue/lib/locale-provider/zh_CN': zhCN,
    // 页面有需要加载react组件的场景才会加载以下的依赖
    // eslint-disable-next-line function-paren-newline
    loadAntd: async () => await import(
      /* webpackChunkName: "antdreactxy_asyncchunk_noexecute" */
      'antd'),
    reactAdaptor: async () => {
      try {
        // eslint-disable-next-line function-paren-newline
        const React = await import(
          /* webpackChunkName: "reactadaptor_asyncchunk_noexecute" */
          'react');
        // eslint-disable-next-line function-paren-newline
        const ReactDOM = await import(
          /* webpackChunkName: "reactadaptor_asyncchunk_noexecute" */
          'react-dom');
        const antd = await window.wujiComp.moduleManage.allWebpackExternals.loadAntd();
        window.antd = antd;
        window.React = React;
        window.ReactDOM = ReactDOM;
        // eslint-disable-next-line function-paren-newline
        const ReactAdaptor = await import(
          /* webpackChunkName: "reactadaptor_asyncchunk_noexecute" */
          '@tencent/wuji-react-adaptor');
        return { React, ReactDOM, ReactAdaptor, antd };
      } catch (err) {
        console.error(err);
      }
    },
    loadVue3Adaptor: async () => {
      try {
        const vue3Bundle = await import('@tencent/wuji-vue-next');
        // eslint-disable-next-line function-paren-newline
        const Vue3Adaptor = await import(
          /* webpackChunkName: "vuenextadaptor_asyncchunk_noexecute" */
          '@tencent/wuji-vue-next-adaptor');

        return {
          Vue3Adaptor,
          vue3: vue3Bundle.default.Vue3,
          vue3Antd: vue3Bundle.default.antdModule,
        };
      } catch (err) {
        console.error(err);
      }
    },
  });
};
